const baseNewsUrl = "New"



  const endpoints = {
    getNewsListFilter:`${baseNewsUrl}/Filter`,
    getNewsDetails:`${baseNewsUrl}`,
    addNews:`${baseNewsUrl}`,
    updatNewsWithPut:`${baseNewsUrl}`,
    deleteNews:`${baseNewsUrl}/Delete`,
   
  };
  
  export default endpoints;
  